(function ($) {
	"use strict";
	// TOP Menu Sticky
	$(window).on('scroll', function () {
		var scroll = $(window).scrollTop();
		if (scroll < 115) {
			$("#sticky-header").removeClass("sticky");
			$('#back-top').fadeIn(500);
		} else {
			$("#sticky-header").addClass("sticky");
			$('#back-top').fadeIn(500);
		}
	});

	$(document).ready(function () {

		// mobile_menu
		var menu = $('ul#navigation');
		if (menu.length) {
			menu.slicknav({
				prependTo: ".mobile_menu",
				closedSymbol: '+',
				openedSymbol: '-'
			});
		};
		// blog-menu
		// $('ul#blog-menu').slicknav({
		//   prependTo: ".blog_menu"
		// });

		// for filter
		// init Isotope

		//for menu active class
		$('.portfolio-menu button').on('click', function (event) {
			$(this).siblings('.active').removeClass('active');
			$(this).addClass('active');
			event.preventDefault();
		});

		// wow js

		// counter 
		$('.counter').counterUp({
			delay: 10,
			time: 10000
		});

		// scrollIt for smoth scroll
		$.scrollIt({
			upKey: 38, // key code to navigate to the next section
			downKey: 40, // key code to navigate to the previous section
			easing: 'linear', // the easing function for animation
			scrollTime: 600, // how long (in ms) the animation takes
			activeClass: 'active', // class given to the active nav element
			onPageChange: null, // function(pageIndex) that is called when page is changed
			topOffset: 0 // offste (in px) for fixed top navigation
		});

		// scrollup bottom to top
		$.scrollUp({
			scrollName: 'scrollUp', // Element ID
			topDistance: '4500', // Distance from top before showing element (px)
			topSpeed: 300, // Speed back to top (ms)
			animation: 'fade', // Fade, slide, none
			animationInSpeed: 200, // Animation in speed (ms)
			animationOutSpeed: 200, // Animation out speed (ms)
			scrollText: '<i class="fa fa-angle-double-up"></i>', // Text for element
			activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
		});

		// blog-page

		//brand-active

		// blog-dtails-page

		//project-active

	});

	// resitration_Form
	/*
	$(document).ready(function () {
		$('.dont-hav-acc').magnificPopup({
			type: 'inline',
			preloader: false,
			focus: '#name',

			// When elemened is focused, some mobile browsers in some cases zoom in
			// It looks not nice, so we disable it:
			callbacks: {
				beforeOpen: function () {
					if ($(window).width() < 700) {
						this.st.focus = false;
					} else {
						this.st.focus = '#name';
					}
				}
			}
		});
	});

*/

	// Search Toggle
	$("#search_input_box").hide();
	$("#search").on("click", function () {
		$("#search_input_box").slideToggle();
		$("#search_input").focus();
	});
	$("#close_search").on("click", function () {
		$('#search_input_box').slideUp(500);
	});
	// Search Toggle
	$("#search_input_box").hide();
	$("#search_1").on("click", function () {
		$("#search_input_box").slideToggle();
		$("#search_input").focus();
	});

})(jQuery);

var drag = {

};
jQuery(function () {

	$("#sortable1").sortable({
		connectWith: "#sortable2"
	}).disableSelection();
	$("#sortable2").sortable({

	}).disableSelection();
 
	/*
	$(".content_area").droppable({
		drop: function (event, ui) {
			//this if condition is for avoiding multiple time drop and attachment of same item
			if (ui.draggable.hasClass("snippet_item") && $(this).find(".deck").length <= 1) {
				var $item = $(ui.helper).clone(); //getting the cloned item
				rel = $item.attr('rel');
				$item.removeClass("snippet_item");

				if (rel == "a") {
					//$item.html("<div id='e1' class='drag_elm-in  '>Item 1</div>");
				} else if (rel == "b") {
					//$item.html("<div id='e2' class='drag_elm-in  '>Item 2</div>");
				} else if (rel == "c") {
					//  $item.html("<div id='e3' class='drag_elm-in   '>Item 3</div>");
				}
				$item.css("top", 0);
				$item.css("left", 0);
				$(this).append($item);
				//makeDraggable($item);
			}
		},
		cursor: 'move',
	})

	jQuery("body").on("click", ".main .deck", function (e) {
		e.preventDefault();
		jQuery(this).fadeOut(500, function () {
			jQuery(this).remove();
		})

	});

	function makeDraggable($item) {
		$item.draggable({
			start: function () {},
			stop: function () {
				console.log('stopped')
			}
		});
	}
	$(".html_blocks").sortable();
 
	jQuery("body").on("click", ".snippet_item", function (e) {
		_content='';
		$flag=true;
		_ctx=jQuery(this).closest("form");
		$.each($(".content_area",_ctx),function(index,value){
			if($(this).find(".deck").length<=0 && $flag==true){
				_content=jQuery(this).attr("id");
				$flag=false;
			}
		});
		var $destino = jQuery("#"+_content);
		if ($destino.find('.deck').length <= 0) {
			jQuery(this).clone().css('position', "absolute").css(jQuery(this).position())
				.appendTo(jQuery(this).parent()).animate($destino.position(), 500, function () {

					jQuery(this).removeClass("snippet_item").css("top", 0).css("left", 0).appendTo($destino);

				});
		}

		//.appendTo(jQuery(this).parent()).animate(jQuery("#content_area").offset(),500);
	});
               
	$(".html_blocks .snippet_item").draggable({

		//containment: "#content_area",
		//appendTo: ".content_area",
		helper: "clone",
		revert: function (socketObj) {
			if (socketObj === false) {
				// Drop was rejected, revert the helper.
				var $helper = $(this);
				console.log("POSITION:");
				console.log($helper.originalPosition);
				//$helper.animate($helper.originalPosition);
				return true;
			} else {
				// Drop was accepted, don't revert.
				return false;
			}
		},
		start: function () {},
		stop: function () {
			console.log('stopped')
		}
	});
*/
});

function makeDrag($obj) {
	$($obj).draggable({

		containment: "#content_area",
		appendTo: "#content_area",
		scroll: false,
		helper: "clone",
		snap: true,
		start: function () {},
		stop: function () {
			console.log('stopped')
		}
	});
}
